export default "__VITE_ASSET__ab16648a__"